import { UncontrolledAlert as Alert } from "reactstrap";

const Success = ({message}) => {
  return (
    <Alert closeClassName="pt-5 fs-6" color="success" style={{fontSize: "14px"}}>{message}</Alert>
  )
}

export default Success